import { RSVPResponseType } from './types';
import { releaseFetchWithOverrideRecovery } from '@/lib/release/pageSourceOverride';

export interface SubmitRsvpCampaignParams {
  eventId: string;
  campaignToken: string;
  response: RSVPResponseType;
  message?: string;
}

export async function submitRsvpCampaignResponse({
  eventId,
  campaignToken,
  response,
  message,
}: SubmitRsvpCampaignParams): Promise<void> {
  try {
    await releaseFetchWithOverrideRecovery(`/e/api/${eventId}/rsvp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        campaignToken,
        response,
        ...(message !== undefined && message.trim() !== '' && { message: message.trim() }),
      }),
    });
  } catch (error) {
    throw new Error(`RSVP request failed: ${error}`);
  }
}

export async function isCampaignTokenValid(eventId: string, campaignToken: string): Promise<boolean> {
  try {
    const response = await releaseFetchWithOverrideRecovery(`/e/api/${eventId}/validate-campaign-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ campaignToken }),
    });

    if (!response.ok) {
      console.error(`MIPA token validation failed.`);
      return false;
    }

    const data = await response.json();
    return data.isValid;
  } catch (error) {
    console.error(`MIPA token validation failed: ${error}`);
    return false;
  }
}
